/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs */

const en_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert surround single music notes to all selected events`)
};

const fr_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer des notes de musique entourees pour tous les evenements selectionnes`)
};

const de_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge allen ausgewählten Ereignissen einzelne Surround-Musiknoten hinzu.`)
};

const it_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci singole note musicali surround a tutti gli eventi selezionati`)
};

const ru_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить отдельные музыкальные ноты в объемном звучании ко всем выбранным событиям`)
};

const es_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar notas musicales envolventes individuales en todos los eventos seleccionados`)
};

const zh_cn2_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为所有选定事件插入环绕单音符音乐`)
};

const ja_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したすべてのイベントにサラウンド単一音符を挿入します`)
};

const hi_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी चयनित इवेंट्स में सराउंड सिंगल म्यूज़िक नोट्स डालें`)
};

const pt_pt2_shortcut_keys_desc_insert_surround_music_note = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir notas musicais individuais em surround em todos os eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Insert surround single music notes to all selected events" |
*
* @param {Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_surround_music_note = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_insert_surround_music_note(inputs)
	if (locale === "de") return de_shortcut_keys_desc_insert_surround_music_note(inputs)
	if (locale === "it") return it_shortcut_keys_desc_insert_surround_music_note(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_insert_surround_music_note(inputs)
	if (locale === "es") return es_shortcut_keys_desc_insert_surround_music_note(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_insert_surround_music_note(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_insert_surround_music_note(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_insert_surround_music_note(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_insert_surround_music_note(inputs)
	return en_shortcut_keys_desc_insert_surround_music_note(inputs)
});